/* eslint-disable no-console */

import { register } from 'register-service-worker'

const version = "1.6.17";

// Create a custom event for update notifications
const createUpdateEvent = (type, data) => {
  const event = new CustomEvent('serviceWorkerUpdate', {
    detail: { type, data, version }
  });
  window.dispatchEvent(event);
};

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('Service worker is ready. Current versions:', version);
      //createUpdateEvent('ready', { version });
    },
    registered () {
      console.log('Service worker has been registered.');
      //createUpdateEvent('registered', { version });
    },
    cached () {
      console.log('Content has been cached for offline use.');
      //createUpdateEvent('cached', { version });
    },
    updatefound () {
      console.log('New content is downloading.');
     // createUpdateEvent('updatefound', { version });
    },
    updated (registration) {
      console.log('New content is available; please refresh.');
      createUpdateEvent('updated', { 
        version,
        registration,
        currentVersion: '1.6.16',
        newVersion: version // This will be updated with actual new version
      });
      
      // Don't auto-reload, let the user choose
      // window.location.reload(true)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.');
      //createUpdateEvent('offline', { version });
    },
    error (error) {
      console.error('Error during service worker registration:', error);
      //createUpdateEvent('error', { version, error });
    }
  })
}
